import BlankEtc from '@components/blank/BlankEtc';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import GiftBoxItem from './GiftBoxItem';
import GiftBoxItemSkeletons from './GiftBoxItemSkeletons';
import usePrepaidGiftBoxes from './hooks/usePrepaidGiftBoxes';

function GiftBox() {
    const { t } = useTranslation('prepaidCard');
    const {
        gifts, isEmpty, isPending, isFetchingNextPage, fetchNextPage, hasNextPage,
    } = usePrepaidGiftBoxes();
    const from = dayjs().subtract(1, 'year').format('YY.MM.DD');
    const to = dayjs().format('YY.MM.DD');

    return (
        <Wrapper>
            <Period>
                <Text size='body-short' color={colors.textSecondary}>
                    {t('giftBox.periodLabel', { from, to })}
                </Text>
            </Period>
            {isPending && <GiftBoxItemSkeletons />}
            {isEmpty && (
                <BlankEtc>
                    <EmptyText>
                        {t('giftBox.empty')}
                    </EmptyText>
                </BlankEtc>
            )}
            {!isPending && !isEmpty && (
                <List>
                    {gifts.map((gift) => (
                        <GiftBoxItem key={gift.id} gift={gift} />
                    ))}
                    {hasNextPage && (
                        <InfinityScrollTrigger trigger={fetchNextPage} />
                    )}
                    {isFetchingNextPage && <GiftBoxItemSkeletons count={1} />}
                </List>
            )}
        </Wrapper>
    );
}

const Wrapper = styled.section`
    display: flex;
    flex-direction: column;
    padding: 16px 20px calc(24px + var(--safe-area-bottom));
    width: 100%;
`;

const Period = styled.div`
    margin-bottom: 8px;
`;

const List = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const EmptyText = styled.span`
    display: block;
    text-align: center;
    white-space: pre-line;
`;

export default GiftBox;
